import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationLoggerService } from './navigation-logger.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly router: Router = inject(Router);
  private readonly navigationLogger: NavigationLoggerService = inject(NavigationLoggerService);

  // Navigate back: pop the most recent history entry, or fall back to the parent URL.
  navigateToPreviousOriginPage(): void {
    const currentUrl = this.router.url;
    const currentCleanUrl = currentUrl.split('?')[0];
    const navigationHistory = this.navigationLogger.getNavigationHistory();

    // Flag the upcoming navigation as a back-navigation so the logger does not corrupt state
    this.navigationLogger.setBackNavigationFlag();

    if (navigationHistory.length > 0) {
      const target = navigationHistory[navigationHistory.length - 1];
      if (target.split('?')[0] !== currentCleanUrl) {
        this.router.navigate([target]);
        return;
      }
    }

    const defaultMasterView = this.navigationLogger.getParentUrl(currentUrl);
    if (defaultMasterView !== currentCleanUrl) {
      this.router.navigate([defaultMasterView]);
    }
  }
}
